var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchX2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Icon-fill-color",
    stroke: "transparent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 2.5C6.52944 2.5 2.5 6.52944 2.5 11.5C2.5 16.4706 6.52944 20.5 11.5 20.5C13.7126 20.5 15.7388 19.7015 17.306 18.3771L20.5478 21.6189C20.9383 22.0094 21.5715 22.0094 21.962 21.6189C22.3525 21.2283 22.3525 20.5952 21.962 20.2047L18.6821 16.9247C19.8231 15.4163 20.5 13.5372 20.5 11.5C20.5 6.52944 16.4706 2.5 11.5 2.5ZM11.5 4.5C7.63401 4.5 4.5 7.63401 4.5 11.5C4.5 15.366 7.63401 18.5 11.5 18.5C15.366 18.5 18.5 15.366 18.5 11.5C18.5 7.63401 15.366 4.5 11.5 4.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchX2);
export default __webpack_public_path__ + "static/media/SearchX2.9115c03206a8f522422c2551e009893c.svg";
export { ForwardRef as ReactComponent };